import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const CortanaLogoReadyInnerIcon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M1024 384q88 0 170 23t153 64 129 100 100 130 65 153 23 170q0 88-23 170t-64 153-100 129-130 100-153 65-170 23q-88 0-170-23t-153-64-129-100-100-130-65-153-23-170q0-88 23-170t64-153 100-129 130-100 153-65 170-23z" />
    </svg>
  ),
  displayName: 'CortanaLogoReadyInnerIcon',
});

export default CortanaLogoReadyInnerIcon;
